import type { FontEntry, FontKey } from './types';

/**
 * The seven fonts admins can pick for heading + paragraph in the Hub.
 * Atlassian Sans is the default and is already loaded by the AK shell —
 * its `googleFontsFamily` is `null`. The other six are loaded via the
 * Google Fonts CSS API at runtime.
 *
 * License: all six non-Atlassian fonts use SIL OFL 1.1 (LEGALPROD-809).
 * See `./LICENSES.md` for the per-font attribution.
 *
 * Note on version pinning: Google Fonts serves whatever version it has
 * deployed — we cannot pin. This is acceptable for v1 because the
 * feature is gated behind two default-OFF Statsig flags. The
 * BE-persistence follow-up PR moves to self-hosted DS CDN with version
 * pinning via the `v1/` path convention.
 */
export const FONT_REGISTRY: Record<FontKey, FontEntry> = {
	'atlassian-sans': {
		displayName: 'Atlassian Sans',
		family: '"Atlassian Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
		category: 'sans-serif',
		googleFontsFamily: null,
	},
	'noto-sans': {
		displayName: 'Noto Sans',
		family: '"Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
		category: 'sans-serif',
		googleFontsFamily: 'Noto+Sans:wght@400;500;700',
	},
	'ibm-plex-sans': {
		displayName: 'IBM Plex Sans',
		family: '"IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
		category: 'sans-serif',
		googleFontsFamily: 'IBM+Plex+Sans:wght@400;500;700',
	},
	'work-sans': {
		displayName: 'Work Sans',
		family: '"Work Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
		category: 'sans-serif',
		googleFontsFamily: 'Work+Sans:wght@400;500;700',
	},
	'ibm-plex-serif': {
		displayName: 'IBM Plex Serif',
		family: '"IBM Plex Serif", Georgia, "Times New Roman", serif',
		category: 'serif',
		googleFontsFamily: 'IBM+Plex+Serif:wght@400;500;700',
	},
	merriweather: {
		displayName: 'Merriweather',
		family: '"Merriweather", Georgia, "Times New Roman", serif',
		category: 'serif',
		googleFontsFamily: 'Merriweather:wght@400;500;700',
	},
	lora: {
		displayName: 'Lora',
		family: '"Lora", Georgia, "Times New Roman", serif',
		category: 'serif',
		googleFontsFamily: 'Lora:wght@400;500;700',
	},
};
